define(function(require, exports, module) {
    'use strict';

    var config = require('config');
    var server = require('server');
    var _ = require('underscore');
    var $ = require('j');
    var Class = require('Class');
    const user = require('user');

    var BetLimits = Class.create({

        UNLIMITED_AMOUNT: '92233720368547758.07', // maximum signed 64 bit integer for a specific IMS behaviour
        isPresentCasinoDefaults: null,

        availablePeriodsMap: { // values correspond to IMS
            1: 'session',
            2: 'daily',
            3: 'weekly',
            4: 'monthly'
        },

        fetchBetLimits: function(currencyCode, isPresentCasinoDefaults) {
            var state = $.Deferred();

            this.isPresentCasinoDefaults = isPresentCasinoDefaults != null
                ? isPresentCasinoDefaults
                : this.isPresentCasinoDefaults;

            server.send({
                    ID: 32942,
                    description: 'Get Rg Configuration',
                    responses: [32943, 32944],
                    type: [4],
                    casino: config.get('casinoName'),
                    ...!user.isLoggedIn() && { currencyCode }
                })
                .done(function(response) {
                    state.resolve(this.success(response));
                }.bind(this))
                .fail(function() {
                    state.reject(this.fail());
                }.bind(this));

            return state;
        },

        success: function(resp) {
            var data = resp.data.betLimitConfigurationItems[0] || {};

            return this.parse(data);
        },

        parse: function(data) {
            if (!data.betLimitEnabled) {
                return { betLimitEnabled: false };
            }

            return {
                betLimitEnabled: true,
                config: {
                    availableTimePeriods: this.getAvailablePeriods(data),
                    predefinedLimits: this.getPredefinedLimits(data),
                    controlType: this.getControlType(data),
                    defaultLimits: this.getDefaultLimits(data),
                    unlimitedAmount: this.UNLIMITED_AMOUNT,
                    noLimitsAllowed: data.noLimitsAllowed,
                    predefinedType: data.predefinedType,
                    mandatory: data.mandatory
                }
            };
        },

        getAvailablePeriods: function(data) {
            return data.availablePeriods.map(function(period) {
                return this.availablePeriodsMap[period];
            }.bind(this));
        },

        getDefaultLimits: function(data) {
            // Key names correspond to IMS
            var defaultLimits = {
                sessionDefaultLimit: 0,
                dailyDefaultLimit: 0,
                monthlyDefaultLimit: 0,
                weeklyDefaultLimit: 0
            };

            if (!this.isPresentCasinoDefaults) {
                return defaultLimits;
            }

            return _.extend({}, defaultLimits, _.pick(data, Object.keys(defaultLimits)));
        },

        getControlType: function(data) {
            var predefinedTypesToControlMap = {
                'disabled': data.noLimitsAllowed ? 'both' : 'text',
                'enabled': 'both',
                'forced': 'list'
            };

            return predefinedTypesToControlMap[data.predefinedType];
        },

        getPredefinedLimits: function(data) {
            var limits = _.clone(data.predefinedLimits || []);

            if (data.noLimitsAllowed) {
                limits.push(this.UNLIMITED_AMOUNT);
            }

            return limits;
        },

        fail: function() {
            return { betLimitEnabled: false };
        }
    });

    module.exports = BetLimits;
});
